<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="page-main">
      <div class="panel-heading">
        <el-button plain icon="el-icon-arrow-left" @click="backToVps"></el-button>
        <span class="se-panel-title z-padding-left-5-precent ver-sub">免费云服务器管理</span>
      </div>
      <div class="server-header" :class="{'server-windows':vpsInfo.OsType_1 === 'Windows','server-centos':vpsInfo.OsType_1 === 'CentOS','server-ubuntu':vpsInfo.OsType_1 === 'Ubuntu','server-close':basic.loading === 'ok' || basic.state.indexOf('关机') === 0}" v-loading="listLoading">
        <table class="server-header-table">
          <tr>
            <td>
              <span class="z-font-size-14 z-color-333">{{vpsInfo.vps_name}}</span>
            </td>
            <td>&nbsp;&nbsp;&nbsp;</td>
            <td>
              <span v-if="basic.loading != 'ok'" class="z-color-green-state state-icon" :class="{'server-state-run':basic.state.indexOf('运行') === 0,'server-state-stop':basic.state.indexOf('关机') === 0}">{{basic.state}}</span>
              <i v-if="basic.loading === 'ok'" class="el-icon-loading z-font-size-16"></i>
              <span v-if="basic.loading === 'ok'" class="z-color-red">{{basic.loading_txt}}</span>
              （{{basic.pstate}}）
            </td>
          </tr>
          <tr>
            <td>IP：{{vpsInfo.ip}}</td>
            <td>&nbsp;&nbsp;&nbsp;</td>
            <td class="z-textAlign-right">到期时间：
              <span v-if="vpsInfo.EndTime.indexOf('2111') != 0" >{{vpsInfo.EndTime}}</span>
              <span v-if="vpsInfo.EndTime.indexOf('2111') == 0" class="z-color-red">终身VIP</span>
            </td>
          </tr>
        </table>
        <el-button v-if="basic.start === 'ok'" type="primary" @click="Starting" style="margin-left: 120px;">启动</el-button>
        <el-button v-if="basic.start != 'ok'" type="primary" style="margin-left: 120px;" disabled>启动</el-button>
        <el-button v-if="basic.reset === 'ok'" type="primary" @click="Restart">重启</el-button>
        <el-button v-if="basic.reset != 'ok'" type="primary" disabled>重启</el-button>
        <el-button v-if="basic.close === 'ok'" type="primary" @click="dialogShutdown = true">关机</el-button>
        <el-button v-if="basic.close != 'ok'" type="primary" disabled>关机</el-button>
        <el-button v-if="basic.vnc === 'ok'" type="primary" @click="VncConnect">VNC连接</el-button>
        <el-button type="primary" @click="activeName = 'seven'">免费延期</el-button>
        <el-button v-if="basic.vnc != 'ok'" type="primary" disabled>VNC连接</el-button>
        <div class="alert-deng z-display-inlineBlock z-margin-left-10-precent" style="width: 266px;">
          云服务器绑定域名需提交域名白名单
          <router-link class="z-color-a" to="/fuwu5">>提交白名单</router-link>
        </div>
      </div>
      <div class="z-margin-bottom-10-precent ub-box">
        <a href="/act/newjuly/" target="_blank" class="ub-box z-width-100-precent guanggao-link">
          <div class="act-box z-textAlign-center z-width-100-precent">
            <span>【特惠产品】</span>
            买2年送1年，北京BGP核心机房，最低932元三年  >>点击购买
          </div>
        </a>
      </div>

      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="基本信息" name="first">
          <el-row>
            <el-col :span="24"><div class="row-title">
              基本信息
            </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-row type="flex" align="middle" class="row-border">
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">名称 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent change-name">
                    {{vpsInfo.vps_name}}
                    <span class="edit-name" title="修改名称" @click="EditName"></span>
                  </div>
                </el-col>
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">备注 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent change-name">
                    {{vpsInfo.vps_remark}}
                    <span class="edit-name" title="修改备注" @click="EditBeizhu"></span>
                  </div>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" class="row-border">
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">公网IP :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent">
                    {{vpsInfo.ip}}
                  </div>
                </el-col>
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">网络类型 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent">
                    {{vpsInfo.NET_TYPE}}
                  </div>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" class="row-border">
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">运行时间 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent">
                    {{runtime}}
                  </div>
                </el-col>
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">操作系统 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <!--<div class="grid-content z-padding-left-20-precent">
                    {{vpsInfo.OsType}}
                  </div>
                  <span v-if="vpsInfo.OsType_1 != 'Windows'">
                    <a class="z-color-a a-underline-link" href="https://www.sanfengyun.com/docs/?id=266&aid=1229" target="_blank">>>免费云服务器装windows系统会性能欠佳的提示</a>
                  </span>-->

                  <div class="grid-content-small z-padding-left-20-precent">
                    <el-row>
                      <div class="grid-content-small z-padding-left-20-precent" style="padding-left: 0">
                        {{vpsInfo.OsType}}
                      </div>
                    </el-row>
                    <el-row>
                      <div class="grid-content-small z-padding-left-20-precent"  style="padding-left: 0">
                        <a class="z-color-a a-underline-link" href="https://www.sanfengyun.com/help/content_1229.html" target="_blank">>>免费云服务器装windows系统会性能欠佳的提示</a>
                      </div>
                    </el-row>
                  </div>

                </el-col>
              </el-row>
              <el-row type="flex" align="middle" class="row-border">
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">创建时间 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent">
                    {{vpsInfo.StartTime}}
                  </div>
                </el-col>
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">到期时间 :</div></el-col>
                <el-col :sm="6" :md="7" :lg="{span:8,pull:1}">
                  <div class="grid-content z-padding-left-20-precent">
                    {{vpsInfo.EndTime}}
                    <el-button class="z-margin-left-10-precent" type="primary" @click="activeName = 'seven'">免费延期</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" class="row-border">
                <el-col :sm="6" :md="5" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">配置信息 :</div></el-col>
                <el-col :sm="18" :md="19" :lg="{span:20,pull:1}">
                  <div class="grid-content-small z-padding-left-20-precent">
                    <el-row>
                      <el-col :span="8" class="z-color-666">CPU：<span class="z-color-green z-font-weight-700">{{vpsInfo.CPU}}核</span></el-col>
                      <el-col :span="8" class="z-color-666">公网带宽：<span class="z-color-green z-font-weight-700">{{vpsInfo.NET_WIDTH}}M</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="8" class="z-color-666">内存：<span class="z-color-green z-font-weight-700">{{vpsInfo.RAM}}G</span></el-col>
                      <el-col :span="8" class="z-color-666">SSD数据盘：<span class="z-color-green z-font-weight-700">{{vpsInfo.SSD}}G</span></el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <div class="z-margin-all-15-precent" style="width: 320px;height: 250px;margin-top: 1rem;" v-loading="ImgListLoading" element-loading-text="图片加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)">
                <img :src="ImgUrl" alt="" >
                <p class="z-textAlign-center z-font-size-18 z-lineHeight-30">服务器当前屏幕状态</p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="安装操作系统" name="second">
          <div class="alert-warn">
            安装操作系统需要的时间，根据系统类型不同，大约在3-5分钟内安装完毕。
          </div>
          <el-row>
            <el-col :span="24"><div class="row-title">
              安装操作系统
            </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4">
              <div class="grid-content z-padding-left-30-precent z-color-muted">宝塔面板说明 :</div>
            </el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="z-padding-left-20-precent" style="line-height: 28px;">
                <p>CentOS内置宝塔面板的系统，安装完毕后，您可以通过访问<span @click="Linux" class="z-curPonit z-color-a a-underline-link">http://{{vpsInfo.ip}}:8888</span>来进行初始化服务器。</p>
                <p><span class="z-color-red z-font-size-12">安装后请务必立刻修改您的宝塔账号和密码。否则服务器有被入侵的危险。</span></p>
                <p>
                  推荐使用 "宝塔面板CentOS"操作系统。
                  <a href="/bt.html" target="_blank" class="z-color-a a-underline-link">宝塔面板介绍></a>
                </p>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4">
              <div class="grid-content z-padding-left-30-precent z-color-muted">Windows系统说明:</div>
            </el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="z-padding-left-20-precent" style="line-height: 28px;">
                <p class="z-color-red">windows系统，默认开通远程桌面连接，端口为12068 <a href="/help/content_1082.html" class="z-color-a a-underline-link" target="_blank">使用方法>></a></p>
                <!--<p>安装后如果 ping 不通，是因为基于安全原因，部分操作系统默认关闭了ping响应。</p>-->
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">选择操作系统类型 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="grid-content z-padding-left-20-precent">
                <el-select v-model="Osnamec" class="z-margin-right-5-precent">
                  <el-option
                    v-for="item in Osname"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="Osid" style="width: 350px">
                  <el-option
                    v-for="item in Oslist"
                    :key="item.sysValue"
                    :label="item.sysName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">操作系统密码 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="grid-content-small z-padding-left-20-precent">
                <el-form :model="OspsdForm" :rules="Ospsdrules" label-width="0" class="psd-form">
                  <el-form-item label="" prop="password" style="margin-top: 10px;margin-bottom: 10px;">
                    <el-input v-show="pas_eye == false" type="password" v-model="OspsdForm.password" style="width: 280px">
                      <i slot="suffix" class="eye-open" @click="pas_eye = true"></i>
                    </el-input>
                    <el-input v-show="pas_eye == true" type="text" v-model="OspsdForm.password" style="width: 280px">
                      <i slot="suffix" class="eye-close" @click="pas_eye = false"></i>
                    </el-input>

                    <!--<el-button type="primary" @click="dialogCaptcha = true,Oscaptcha = ''" style="background-color: #ff7d26;border-color: #ff6f0f;opacity: 0.7;vertical-align: top;">点击获取</el-button>-->
                  </el-form-item>
                  <el-form-item label="" prop="name" style="margin-bottom: 0">
                    <!--<span class="z-color-red z-font-size-12">为保证您的服务器安全，请通过您的绑定手机（{{phone}}），获取操作系统密码才可以进行安装。</span>-->
                    <span class="z-color-red z-font-size-12">请输入8~32位密码(必须包含大写字母和小写字母和数字)</span>
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">验证码 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="grid-content-small z-padding-left-20-precent">
                <el-input v-model="Oscaptcha" style="width: 200px"></el-input>
                <img :src="captcha" title="点击更换" class="error-img" @click="changeYzm">
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted">安装方式 :</div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="grid-content-small z-padding-left-20-precent">
                <div class="z-margin-bottom-5-precent">
                  <el-radio v-model="Osstyle" label="new" class="z-margin-right-20-precent">全新安装</el-radio> <span class="z-font-size-12 z-color-66-orange">（第一次安装请选择这一项）</span>
                </div>
                <div class="z-margin-bottom-5-precent">
                  <el-radio v-model="Osstyle" label="cpan" class="z-margin-right-20-precent">只安装系统盘</el-radio>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" align="middle" class="row-border">
            <el-col :sm="6" :md="4" :lg="4"><div class="grid-content z-padding-left-30-precent z-color-muted"></div></el-col>
            <el-col :sm="18" :md="20" :lg="{span:20,pull:1}">
              <div class="grid-content z-padding-left-20-precent">
                <el-button type="primary" v-if="basic.loading != 'ok'" @click="submitForm2('OspsdForm')" style="background-color: #ff7d26;border-color: #ff6f0f;">开始安装</el-button>
                <el-button type="primary" v-if="basic.loading === 'ok'" style="background-color: #ff7d26;border-color: #ff6f0f;opacity: 0.7" disabled>开始安装</el-button>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="重设密码" name="reset-password">
          <div class="alert-warn">
            <p>1.Windows系统修改密码后大约30秒左右生效。</p>
            <p>2.Linux修改密码需要重新启动两次，大约需要3-5分钟生效</p>
          </div>
          <el-row>
            <el-col :span="24"><div class="row-title">
              修改密码
            </div>
            </el-col>
          </el-row>
          <div class="grid-content z-padding-left-20-precent">
            <el-form :model="psdForm" :rules="psdrules" ref="psdForm" label-width="100px" class="psd-form">
              <el-form-item label="用户名：" prop="name" style="margin-top: 20px">
                <el-input v-model="vpsInfo.adminuser" style="width: 280px" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="输入密码：" prop="password" style="margin-bottom: 10px">
                <el-input type="password" v-model="psdForm.password" style="width: 280px"></el-input>
              </el-form-item>
              <el-form-item label="" prop="password" style="margin-bottom: 10px">
                <span class="z-color-red z-font-size-12">请输入8~32位密码(必须包含大写字母和小写字母和数字)</span>
              </el-form-item>
              <el-form-item label="确认密码：" prop="checkPass">
                <el-input type="password" v-model="psdForm.checkPass" style="width: 280px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" v-if="basic.loading != 'ok'" @click="submitForm('psdForm')" style="background-color: #ff7d26;border-color: #ff6f0f;">确定</el-button>
                <el-button type="primary" v-if="basic.loading === 'ok'" style="background-color: #ff7d26;border-color: #ff6f0f;opacity: 0.7" disabled>确定</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="快照管理" name="third">
          <el-button v-show="Kuaizhao.type === 'log'" size="mini" @click="Kuaizhao.type = 'list'">快照列表</el-button>
          <el-button v-show="Kuaizhao.type === 'list'" type="primary" size="mini" style="margin-left: 0">快照列表</el-button>
          <el-button v-show="Kuaizhao.type === 'list'" size="mini" @click="Kuaizhao.type = 'log'">快照日志</el-button>
          <el-button v-show="Kuaizhao.type === 'log'" type="primary" size="mini">快照日志</el-button>
          <el-table v-show="Kuaizhao.type === 'list'"  v-loading="dialogSnaploading" :data="tableSnap" border style="width: 100%;margin-top: 20px">
            <el-table-column prop="type" align="center" label="快照类型">
            </el-table-column>
            <el-table-column prop="state" align="center" label="快照创建状态">
              <template slot-scope="scope">
                <span v-show="scope.row.state.indexOf('正在') == -1" class="z-color-green">{{scope.row.state}}</span>

                <div v-show="scope.row.state.indexOf('正在') !=-1" class="host-uselevel-bar progress">
                  <div class="progress-bar progress-bar-blue" :style="'width: '+ scope.row.rate +'%'">
                  </div>
                  <span class="usage-text" :title="scope.row.state">
										<span class="z-color-66-orange">{{scope.row.rate}}%</span>/<span class="z-color-666">{{scope.row.state}}</span>
										</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="time" align="center" label="快照创建时间">
              <template slot-scope="scope">
                <span class="z-color-green">{{scope.row.time}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="size" align="center" label="快照大小">
              <template slot-scope="scope">
                <span class="z-color-green">{{scope.row.size}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="caozuo" label="操作">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="dialogProtect = true,snapevent = 'back',snaptype = scope.row.type,changeYzm(),Kuaizhao.captcha = ''">还原快照</el-button>
                <el-button v-if="scope.row.type === '用户快照'" type="info" size="mini" @click="dialogProtect = true,snapevent = 'create',snaptype = '用户快照',changeYzm(),Kuaizhao.captcha = ''">创建快照</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-show="Kuaizhao.type === 'log'" :data="tableSnaplog" border style="width: 100%;margin-top: 20px">
            <el-table-column prop="time" align="center" label="时间" width="350">
            </el-table-column>
            <el-table-column prop="event" align="center" label="事件">
              <template slot-scope="scope">
                <span class="z-color-green">{{scope.row.event}}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination v-show="Kuaizhao.type === 'log'" background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="流量统计" name="fourth">
          <div class="z-margin-bottom-15-precent">
            当前IP：({{vpsInfo.ip}})
          </div>
          <div class="server-monitor-content clearfix list">
            <div class="server-monitor-box">
              <div class="server-monitor-btn">
                <el-button v-show="minubtn === 'max'" size="mini" @click="NetLiuliang('minu','avg')" style="margin-left: 10px">平均</el-button>
                <el-button v-show="minubtn === 'avg'" type="primary" size="mini">平均</el-button>
                <el-button v-show="minubtn === 'avg'" size="mini" @click="NetLiuliang('minu','max')" style="margin-left: 10px">最大</el-button>
                <el-button v-show="minubtn === 'max'" type="primary" size="mini">最大</el-button>
              </div>
              <div id="netMinu" class="charts-container" v-loading="dialogNetMinu">
              </div>
            </div>
            <div class="server-monitor-box">
              <div class="server-monitor-btn">
                <el-button v-show="hourbtn === 'max'" size="mini" @click="NetLiuliang('hour','avg')" style="margin-left: 10px">平均</el-button>
                <el-button v-show="hourbtn === 'avg'" type="primary" size="mini">平均</el-button>
                <el-button v-show="hourbtn === 'avg'" size="mini" @click="NetLiuliang('hour','max')" style="margin-left: 10px">最大</el-button>
                <el-button v-show="hourbtn === 'max'" type="primary" size="mini">最大</el-button>
              </div>
              <div id="netHour" class="charts-container" v-loading="dialogNetHour">

              </div>
            </div>
            <div class="server-monitor-box">
              <div class="server-monitor-btn">
                <el-button v-show="daybtn === 'max'" size="mini" @click="NetLiuliang('day','avg')" style="margin-left: 10px">平均</el-button>
                <el-button v-show="daybtn === 'avg'" type="primary" size="mini">平均</el-button>
                <el-button v-show="daybtn === 'avg'" size="mini" @click="NetLiuliang('day','max')" style="margin-left: 10px">最大</el-button>
                <el-button v-show="daybtn === 'max'" type="primary" size="mini">最大</el-button>
              </div>
              <div id="netDay" class="charts-container" v-loading="dialogNetDay">

              </div>
            </div>
            <div class="server-monitor-box">
              <div class="server-monitor-btn">
                <el-button v-show="monthbtn === 'max'" size="mini" @click="NetLiuliang('month','avg')" style="margin-left: 10px">平均</el-button>
                <el-button v-show="monthbtn === 'avg'" type="primary" size="mini">平均</el-button>
                <el-button v-show="monthbtn === 'avg'" size="mini" @click="NetLiuliang('month','max')" style="margin-left: 10px">最大</el-button>
                <el-button v-show="monthbtn === 'max'" type="primary" size="mini">最大</el-button>
              </div>
              <div id="netMonth" class="charts-container" v-loading="dialogNetMonth">

              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="cpu使用统计" name="five">
          <div class="z-margin-bottom-15-precent">
            当前IP：({{vpsInfo.ip}})
          </div>
          <div class="server-monitor-content clearfix cpu">
            <div class="server-monitor-box" v-loading="dialogCpu">
              <div id="cpu" class="charts-container">

              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="磁盘使用统计" name="six">
          <div class="z-margin-bottom-15-precent">
            当前IP：({{vpsInfo.ip}})
          </div>
          <div class="server-monitor-content clearfix cpu">
            <div class="server-monitor-box" v-loading="dialogIops">
              <div id="iops" class="charts-container">

              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="免费延期" name="seven" v-loading="delayLoading">
          <div class="alert-info">
            1、为了节约系统资源，保留活跃用户，进一步发展免费云服务器，我们采用了定期申请延期的方案，免费产品到期后会自动删除，请及时延期或备份。<br>
            2、延期方式：发布使用感受在我们推荐的网站或其他同类的网站中 <a href="/help/content_1156.html" class="z-color-a z-curPonit a-underline-link" target="_blank">>>查看延期内容要求</a>
            <br>
            3、推荐发帖网站：<a href="/help/content_1009.html" class="z-color-a z-curPonit a-underline-link" target="_blank">>>点击查看推荐延期发帖网站</a>
            <!--<a v-for="item in post_addr" :href="item.href" class="z-color-a z-curPonit a-underline-link z-margin-right-5-precent" target="_blank">{{item.title}}</a>-->
            <br>
            4、发表后一小时内把发布截图在下方提交，工作时间三小时审核完成，如删除将会审核失败。
          </div>
          <div class="alert-deng" style="width: 228px;">
            每次延期成功可以增加 <span class="red-chunk">5</span> 天使用时间。
          </div>
          <el-form ref="cardForm" label-width="120px" class="clearfix">
            <el-form-item v-if="delayState == '审核通过'" label="发帖地址：">
              <el-input v-model="cardForm.url" placeholder="请输入发帖网址http://" style="width: 500px"></el-input>
            </el-form-item>
          </el-form>
          <el-form :inline="true" ref="cardForm" label-width="120px" class="clearfix">
            <!--<el-form-item label="微信账号：" style="margin-right: 4rem">
              <span v-if="weixin">微信帐号已经绑定（{{nickname}}）</span>
              <br v-if="weixin">
              <img v-if="weixin" :src="headimgurl" alt="微信头像" >
              <span v-if="!weixin">微信帐号尚未绑定，<router-link to="/weixin" class="z-color-a">点击这里绑定>></router-link></span>
            </el-form-item>-->
            <el-form-item v-if="delayState == '审核通过'" label="发帖截图：">
              <div class="ub-box">
                <div class="ub-box">
                  <div class="col-img">
                    <label for="fileImg1" class="z-curPonit">
                      <img v-show="!showimg" src="../../assets/imgs/img3.png" alt="请上传现场图片" width="135" height="102">
                    </label>
                    <label for="fileImg1" class="z-curPonit">
                      <img v-show="showimg" :src="dataUrl" width="135" height="102"/>
                    </label>
                  </div>
                </div>
                <div class="z-margin-left-15-precent">
                  <p class="gff8 z-font-size-14">JPG或PNG格式</p>
                  <p class="z-font-size-12 z-color-999 z-padding-bottom-5-precent">请上传发帖截图</p>
                  <label for="fileImg1" class="choose-file">选择文件</label>
                  <input type="file" id="fileImg1" name="CertImg" @change="handleFileChange" ref="inputer" class="z-width-30-precent" style="visibility: hidden;">
                </div>
              </div>
              <el-button type="primary" @click="submitrForm" class="z-margin-top-20-precent">提交</el-button>
            </el-form-item>
            <el-form-item v-if="delayState == 0" label="">
              <div class="delaybox">
                <p class="z-font-size-22 z-color-red z-lineHeight-90">您还未到需要提交延期的时间</p>
                <p class="z-font-size-13 z-color-000">请在{{nexttime}}后提交</p>
              </div>
            </el-form-item>
            <el-form-item v-if="delayState == '待审核'" label="">
              <div class="delaybox">
                <p class="z-font-size-22 z-color-red z-lineHeight-90">延期申请等待审核中</p>
                <p class="z-font-size-13 z-color-000">我们将在工作时间3小时内审核完成</p>
                <p class="z-font-size-13 z-color-000">您可以稍作休息或做其他工作稍后来查看</p>
              </div>
            </el-form-item>
            <el-form-item v-if="delayState != '审核通过' && delayState != 0 && delayState != '待审核'" label="">
              <div class="delaybox">
                <p class="z-font-size-22 z-color-red z-lineHeight-90">延期审核失败</p>
                <p class="z-font-size-13 z-color-000">原因：{{delayState}}</p>
                <p>
                  <a href="/help/content_1156.html" class="z-color-a z-curPonit a-underline-link z-font-size-13" target="_blank">
                    >>查看失败原因和延期内容要求
                  </a>
                </p>
                <el-button type="primary" class="z-margin-top-5-precent" @click="delayState = '审核通过'">重新提交</el-button>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="延期记录" name="eight">
          <el-table :data="cardList" highlight-current-row show-header v-loading="listLoading" style="width: 100%;">
            <el-table-column prop="id" label="序号" align="left">
              <template slot-scope="scope">
                <span class="z-padding-left-5-precent">{{scope.row.id}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Img" label="发帖截图" min-width="200" align="left">
              <template slot-scope="scope">
                <a href="javascript:;" @click="LargeImg(scope.row.Img)">
                  <img :src="scope.row.Img" alt="发帖截图" width="135" style="max-height: 135px">
                </a>
              </template>
            </el-table-column>
            <el-table-column prop="Url" label="网址" min-width="200" align="left">
              <template slot-scope="scope">
                <a :href="scope.row.Url" class="z-color-a z-curPonit a-underline-link" target="_blank">{{scope.row.Url}}</a>
              </template>
            </el-table-column>
            <el-table-column prop="SetTime" label="提交时间" align="left">
            </el-table-column>
            <el-table-column prop="CheckTime" label="审核时间" align="left">
            </el-table-column>
            <el-table-column prop="State" label="状态" align="left">
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="20" :total="total1" class="pull-left">
          </el-pagination>
          <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange1" :page-size="count1" :total="total1">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
      <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
      <xdialog-warning :dialogWarning="dialogWarning" :warningMsg="warningMsg"></xdialog-warning>
      <el-dialog
        title="实例名称"
        :visible.sync="dialogEditname"
        top="12%"
        width="500px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <div class="alert-warn">
          注：修改后方便于管理，不会影响服务器配置，请您放心操作。
        </div>
        <el-form label-width="135px" label-position="right">
          <el-form-item label="IP地址：">
            {{vpsInfo.ip}}
          </el-form-item>
          <el-form-item label="自定义名称：">
            <el-input v-model="remark.vps_name" style="width: 200px"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="RemarkEdit">确 定</el-button>
            <el-button @click="dialogEditname = false">取 消</el-button>
          </span>
      </el-dialog>
      <el-dialog
        title="备注"
        :visible.sync="dialogEditBeizhu"
        top="12%"
        width="500px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <div class="alert-warn">
          注：修改后方便于管理，不会影响服务器配置，请您放心操作。
        </div>
        <el-form label-width="135px" label-position="right">
          <el-form-item label="IP地址：">
            {{vpsInfo.ip}}
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="remark.vps_remark" style="width: 200px"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="RemarkEdit">确 定</el-button>
            <el-button @click="dialogEditBeizhu = false">取 消</el-button>
          </span>
      </el-dialog>
      <el-dialog
        title="关闭云服务器"
        :visible.sync="dialogShutdown"
        top="18.5%"
        width="500px"
        :lock-scroll=false
        custom-class="dialog">
        <p class="z-margin-bottom-10-precent"><span class="z-font-size-12 z-color-muted z-margin-left-20-precent">请选择您的关机方式：</span></p>
        <div class="z-margin-bottom-5-precent">
          <el-radio v-model="shutdowntype" label="shutdown" class="z-margin-h-20-precent">正常关机</el-radio> <span class="z-font-size-12 z-color-66-orange">[推荐]</span>
        </div>
        <div class="z-margin-bottom-5-precent">
          <el-radio v-model="shutdowntype" label="close" class="z-margin-h-20-precent">强制关机</el-radio> <span class="z-font-size-12 z-color-muted">强制关机可能会导致未保存的数据丢失</span>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShutdown = false">取 消</el-button>
        <el-button type="primary" @click="ShutDown">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="管理终端"
        :visible.sync="dialogVnc"
        top="12%"
        width="450px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <div class="alert-warn">
          注：默认为初始系统密码，如无法连接请修改连接密码
        </div>
        <div class="z-textAlign-center">
          <el-button size="medium" type="primary" style="width: 160px;">连接管理终端</el-button>
          <br>
          <br>
          <el-button size="medium" type="primary" plain style="width: 160px;">修改连接密码</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="操作保护"
        :visible.sync="dialogProtect"
        top="18.5%"
        width="660px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog">
        <div v-if="snapevent === 'back'" class="alert-warn">
          还原快照会覆盖服务器现有数据，确认还原请输入验证码继续操作，不需要还原请取消
        </div>
        <div v-if="snapevent === 'create'" class="alert-warn">
          创建快照会覆盖现有快照，确认创建请输入验证码继续操作，不需要创建请取消
        </div>
        <span class="z-font-size-12">为保证您的网站安全，请输入验证码：</span>
        <el-input v-model="Kuaizhao.captcha" style="width: 200px"></el-input>
        <img :src="captcha" title="点击更换" class="error-img" @click="changeYzm">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="Snap">确 定</el-button>
          <el-button @click="dialogProtect = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="dialogShowImg"
        top="2%"
        :lock-scroll=false
        width="26%"
        custom-class="show-img">
        <img width="100%" :src="showimgurl" alt="">
      </el-dialog>
      <el-dialog
        title="请输入验证码"
        :visible.sync="dialogCaptcha"
        top="18.5%"
        width="375px"
        :lock-scroll=false
        :close-on-click-modal=false
        :close-on-press-escape=false
        custom-class="dialog"
        @close="changeYzm()">
        <el-input v-model="Oscaptcha" style="width: 200px"></el-input>
        <img :src="captcha" title="点击更换" class="error-img" @click="changeYzm">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="getPsd">确 定</el-button>
          <el-button @click="dialogCaptcha = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import VpsService from 'business/VpsService.js'
  import userService from 'business/userService.js'
  import renewService from 'business/renewService.js'
  import upgradeService from 'business/upgradeService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import XdialogWarning from 'components/commons/XdialogWarning.vue'
  import echarts from 'echarts/lib/echarts'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value !== this.psdForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        listLoading:false,
        ImgListLoading:false,
        dialogLoading:false,
        dialogSnaploading:false,
        dialogWarning:false,
        dialogEditname:false,
        dialogEditBeizhu:false,
        dialogNetMinu:false,
        dialogNetHour:false,
        dialogNetDay:false,
        dialogNetMonth:false,
        dialogCpu:false,
        dialogIops:false,
        dialogVnc:false,
        dialogShutdown:false,
        dialogProtect:false,
        dialogCaptcha:false,
        dialogXufei:false,
        dialogXLevel:false,
        delayLoading:false,
        dialogShowImg:false,
        warningMsg:'',
        activeName:'first',
        vps:{},
        vpsInfo:{
          EndTime:''
        },
        remark:{
          vps_name:'',
          vps_remark:''
        },
        xufeiForm:{
          id:'',
          ip:'',
          endtime:'',
          region: '1',
          coupon:'',
          yhq:[],
          newtime:'',
          price:'',
          loading:false,
          money:''
        },
        shengjiForm:{
          ip:'',
          cpu:'',
          Cpu:[
            {
              value: '1',
              label: '1核'
            },
            {
              value: '2',
              label: '2核'
            },
            {
              value: '4',
              label: '4核'
            },
            {
              value: '8',
              label: '8核'
            },
            {
              value: '16',
              label: '16核'
            },
          ],
          ram:'',
          Ram:[
            {
              value: '1',
              label: '1G'
            },
            {
              value: '2',
              label: '2G'
            },
            {
              value: '4',
              label: '4G'
            },
            {
              value: '8',
              label: '8G'
            },
          ],
          ssd:1,
          minssd:1,
          bandwidth:1,
          minbandwidth:1,
          coupon:'',
          yhq:[],
          endtime:'',
          price:'0',
          loading:false,
          money:''
        },
        runtime:'',
        basic:{
          pstate:'',
          state:'',
          close: '',
          reset: '',
          start: '',
          vnc: '',
          loading:'',
          loading_txt:''
        },
        ImgUrl:'',
        timer: null,
        minubtn:'avg',
        hourbtn:'avg',
        daybtn:'avg',
        monthbtn:'avg',
        session_id:'',
        shutdowntype:'shutdown',
        Osname:{},
        Osdata:{},
        Oslist:{},
        Osnamec:'CentOS',
        Osid:'',
        Osstyle:'new',
        password:'',
        Oscaptcha:'',
        psdForm:{
          password:'',
          checkPass:'',
        },
        OspsdForm:{
          password:''
        },
        Kuaizhao:{
          type:'list',
          captcha:''
        },
        tableSnap:[],
        tableSnaplog:[],
        snapevent:'',
        snaptype:'',
        psdrules:{
          password: [
            { required: true, message: '密码格式不正确', trigger: 'blur' },
            { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,32}$/ , message: '密码格式不正确' },
          ],
          checkPass: [
            { validator: validatePass, trigger: 'blur' }
          ]
        },
        Ospsdrules:{
          password: [
            { required: true, message: '密码格式不正确', trigger: 'blur' },
            { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,32}$/ , message: '密码格式不正确' },
          ]
        },
        cardForm:{
          url:''
        },
        dataUrl:'',
        showimg:false,
        captcha:'https://api.sanfengyun.com/www/yzm.php?rnd='+Math.random(),
        total:0,
        page:1,
        weixin:Boolean,
        delayState:'',
        nexttime:'',
        nickname:'',
        headimgurl:'',
        cardList: [],
        post_addr:[],
        count1:20,
        total1:0,
        page1:1,
        showimgurl:'',
        phone:'',
        pas_eye:false
      }
    },
    components:{
      XdialogLoading,
      XdialogWarning
    },
    props:{
      hide:Boolean
    },
    created() {
      this.timer = setInterval(() => {
        this.VpsState()
        if(this.activeName === 'first'){
          this.getRunTime()
          this.getVpsImg()
        }
      }, 60000)
    },
    mounted() {
      this.activeName = this.delay
      this.config()
      this.getPhone()
    },
    beforeDestroy() {
      if(this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
        clearInterval(this.timer); //关闭
      }
      if(this.timer3) { //如果定时器还在运行 或者直接关闭，不用判断
        clearInterval(this.timer3); //关闭
      }
    },
    computed: {
      state() {
        if(this.snaptype === '用户快照'){
          return this.tableSnap[0].state
        }
        if(this.snaptype === '系统快照'){
          return this.tableSnap[1].state
        }
      },
      region() {
        return this.xufeiForm.region
      },
      coupon() {
        return this.xufeiForm.coupon
      },
      coupon2() {
        return this.shengjiForm.coupon
      },
      cpu() {
        return this.shengjiForm.cpu
      },
      ram() {
        return this.shengjiForm.ram
      },
      ...mapGetters({
        delay:'getDelay'
      })
    },
    watch:{
      activeName(val){
        if(val === 'second'){
          this.vps_oslist()
        }
        if(val === 'third'){
          this.kz_list()
          this.kz_log_list()
        }
        if(val === 'fourth'){
          this.NetLiuliang('all','avg')
        }
        if(val === 'five'){
          this.CpuLiuliang()
        }
        if(val === 'six'){
          this.IopsLiuliang()
        }
        if(val === 'seven'){
          /*this.checkWeiXin()*/
          this.checkDelay()
          this.getPostAddr()
        }
        if(val === 'eight'){
          this.SearchCard()
        }
      },
      Osnamec(val){
        this.Oslist = this.Osdata.filter(item => {
          return item.win_linux === this.Osnamec
        })
        this.Osid = this.Oslist[0].id
        if(val == 'Windows'){
          this.Windows()
        }
      },
    },
    methods:{
      async config() {
        this.vps = sessionStorage.getItem('vps') ? JSON.parse(sessionStorage.getItem('vps')) : {'id': this.$route.params.id}
        this.VpsQuery()
        this.VpsState()
        this.getRunTime()
        this.getVpsImg()
      },
      backToVps(){
        this.$router.push('/serverList')
      },
      async VpsQuery() {
        this.listLoading = true
        let data = 'cmd=vps_list'+
          '&vps_type=free'+
          '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.vpsInfo = vueData.msg.content[0]
          this.session_id = vueData.msg.session_id
          this.listLoading = false
        }else {
          this.listLoading = false
          this.dialogWarning = true
          this.warningMsg = vueData.msg
        }
      },
      Interval(){
        setInterval(() => {
          this.VpsState()
          this.getRunTime()
          this.getVpsImg()
        }, 60000)
      },
      async VpsState() {
        let data = 'cmd=get_vps_state'+
          '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000') {
          this.basic.state = vueData.msg
          this.basic.pstate = vueData.Pstate
          this.basic.close = vueData.close
          this.basic.reset = vueData.reset
          this.basic.start = vueData.start
          this.basic.vnc = vueData.vnc
          this.basic.loading = vueData.loading
          this.basic.loading_txt = vueData.loading_txt
        }else {
          this.$toast('刷新试一下','fail')
        }
      },
      async getRunTime() {
        let data = 'cmd=getRunTime'+
          '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.runtime = vueData.msg
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async getVpsImg() {
        this.ImgListLoading = true
        let data = 'cmd=getVpsImg'+
          '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.ImgUrl = vueData.img.split('<img src=\'')[1].split('\' />')[0]
          this.ImgListLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async Starting(){
        MessageBox.confirm('是否确定启动？', '启动云服务器', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          this.dialogLoading = true
          let data = 'cmd=vps_control'+
            '&id='+ this.vps.id +
            '&cmd_type=start'
          let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.VpsState()}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });

      },
      async Restart(){
        MessageBox.confirm('强制重启可能会导致未保存的数据丢失', '重启服务器', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'info'
        }).then(async() => {
          this.dialogLoading = true
          let data = 'cmd=vps_control'+
            '&id='+ this.vps.id +
            '&cmd_type=reset'
          let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.VpsState()}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });

      },
      async ShutDown(){
        this.dialogLoading = true
        let data;
        if(this.shutdowntype === 'close'){
          data = 'cmd=vps_control'+
            '&id='+ this.vps.id +
            '&cmd_type=close'
        }
        if(this.shutdowntype === 'shutdown'){
          data = 'cmd=vps_control'+
            '&id='+ this.vps.id +
            '&cmd_type=shutdown'
        }
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogShutdown = false
              self.VpsState()
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      EditName(){
        this.remark.vps_name = this.vpsInfo.vps_name
        this.remark.vps_remark = this.vpsInfo.vps_remark
        this.dialogEditname = true
      },
      EditBeizhu(){
        this.remark.vps_name = this.vpsInfo.vps_name
        this.remark.vps_remark = this.vpsInfo.vps_remark
        this.dialogEditBeizhu = true
      },
      async RemarkEdit() {
        this.dialogLoading = true
        let data = 'cmd=remark_edit'+
          '&id='+ this.vpsInfo.id +
          '&vps_name='+ this.remark.vps_name +
          '&vps_remark='+ this.remark.vps_remark
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogEditname = false
              self.dialogEditBeizhu = false
              self.VpsQuery()
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async NetLiuliang(btn,type) {
        if(btn === 'minu'){
          if(type === 'avg'){
            this.minubtn = 'avg'
          }
          if(type === 'max'){
            this.minubtn = 'max'
          }
        }
        if(btn === 'hour'){
          if(type === 'avg'){
            this.hourbtn = 'avg'
          }
          if(type === 'max'){
            this.hourbtn = 'max'
          }
        }
        if(btn === 'day'){
          if(type === 'avg'){
            this.daybtn = 'avg'
          }
          if(type === 'max'){
            this.daybtn = 'max'
          }
        }
        if(btn === 'month'){
          if(type === 'avg'){
            this.monthbtn = 'avg'
          }
          if(type === 'max'){
            this.monthbtn = 'max'
          }
        }
        if(btn === 'all'){
          this.dialogNetMinu = true
          this.dialogNetHour = true
          this.dialogNetDay = true
          this.dialogNetMonth = true
        }
        let data = 'cmd=sys_report' +
          '&id='+ this.vps.id +
          '&cmd_type=net'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000' ) {
          //计算单位
          let minuavgunit = this.bpsToSize2(vueData.minu.length > 0 ? (this.getiavgMax(vueData.minu) > this.getoavgMax(vueData.minu) ? this.getiavgMax(vueData.minu) : this.getoavgMax(vueData.minu)) : '')
          let minumaxunit = this.bpsToSize2(vueData.minu.length > 0 ? (this.getimaxMax(vueData.minu) > this.getomaxMax(vueData.minu) ? this.getimaxMax(vueData.minu) : this.getomaxMax(vueData.minu)) : '')

          let houravgunit = this.bpsToSize2(vueData.hour.length > 0 ? (this.getiavgMax(vueData.hour) > this.getoavgMax(vueData.hour) ? this.getiavgMax(vueData.hour) : this.getoavgMax(vueData.hour)) : '')
          let hourmaxunit = this.bpsToSize2(vueData.hour.length > 0 ? (this.getimaxMax(vueData.hour) > this.getomaxMax(vueData.hour) ? this.getimaxMax(vueData.hour) : this.getomaxMax(vueData.hour)) : '')

          let dayavgunit = this.bpsToSize2(vueData.day.length > 0 ? (this.getiavgMax(vueData.day) > this.getoavgMax(vueData.day) ? this.getiavgMax(vueData.day) : this.getoavgMax(vueData.day)) : '')
          let daymaxunit = this.bpsToSize2(vueData.day.length > 0 ? (this.getimaxMax(vueData.day) > this.getomaxMax(vueData.day) ? this.getimaxMax(vueData.day) : this.getomaxMax(vueData.day)) : '')

          let monthavgunit = this.bpsToSize2(vueData.month.length > 0 ? (this.getiavgMax(vueData.month) > this.getoavgMax(vueData.month) ? this.getiavgMax(vueData.month) : this.getoavgMax(vueData.month)) : '')
          let monthmaxunit = this.bpsToSize2(vueData.month.length > 0 ? (this.getimaxMax(vueData.month) > this.getomaxMax(vueData.month) ? this.getimaxMax(vueData.month) : this.getomaxMax(vueData.month)) : '')
          let netMinu = echarts.init(document.getElementById('netMinu'));
          let netHour = echarts.init(document.getElementById('netHour'));
          let netDay = echarts.init(document.getElementById('netDay'));
          let netMonth = echarts.init(document.getElementById('netMonth'));
          let optionMinu = {
            title: {
              text: '分钟带宽统计图' + '(单位:'+ (type ==='avg' ? minuavgunit : minumaxunit) +')',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14,
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit + '<br />' + '流出带宽：' + params[1].value + params[1].data.unit;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '流入带宽'){
                    return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit;
                  }
                  if(params[0].seriesName === '流出带宽'){
                    return params[0].name + '<br />' + '流出带宽：' + params[0].value + params[0].data.unit;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['流入带宽','流出带宽'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.minu.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.time
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ (type ==='avg' ? minuavgunit : minumaxunit)
              }
            },
            series: [
              {
                name:'流入带宽',
                data: vueData.minu.map((item, index) => {
                  if(type ==='avg'){
                    return {
                      value:this.bpsToSize(item.i_f_all_avg,minuavgunit),
                      unit:minuavgunit
                    }
                  }
                  if(type ==='max'){
                    return {
                      value:this.bpsToSize(item.i_f_all_max,minumaxunit),
                      unit:minumaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'流出带宽',
                data: vueData.minu.map((item, index) => {
                  if(type === 'avg'){
                    return {
                      value:this.bpsToSize(item.o_f_all_avg,minuavgunit),
                      unit:minuavgunit
                    }
                  }
                  if(type === 'max'){
                    return {
                      value:this.bpsToSize(item.o_f_all_max,minumaxunit),
                      unit:minumaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          let optionHour = {
            title: {
              text: '小时带宽统计图' + '(单位:'+ (type ==='avg' ? houravgunit : hourmaxunit) +')',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit + '<br />' + '流出带宽：' + params[1].value + params[1].data.unit;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '流入带宽'){
                    return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit;
                  }
                  if(params[0].seriesName === '流出带宽'){
                    return params[0].name + '<br />' + '流出带宽：' + params[0].value + params[0].data.unit;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['流入带宽','流出带宽'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.hour.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.time
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ (type ==='avg' ? houravgunit : hourmaxunit)
              }
            },
            series: [
              {
                name:'流入带宽',
                data: vueData.hour.map((item, index) => {
                  if(type ==='avg'){
                    return {
                      value:this.bpsToSize(item.i_f_all_avg,houravgunit),
                      unit:houravgunit
                    }
                  }
                  if(type ==='max'){
                    return {
                      value:this.bpsToSize(item.i_f_all_max,hourmaxunit),
                      unit:hourmaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'流出带宽',
                data: vueData.hour.map((item, index) => {
                  if(type === 'avg'){
                    return {
                      value:this.bpsToSize(item.o_f_all_avg,houravgunit),
                      unit:houravgunit
                    }
                  }
                  if(type === 'max'){
                    return {
                      value:this.bpsToSize(item.o_f_all_max,hourmaxunit),
                      unit:hourmaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          let optionDay = {
            title: {
              text: '日带宽统计图' + '(单位:'+ (type ==='avg' ? dayavgunit : daymaxunit) +')',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit + '<br />' + '流出带宽：' + params[1].value + params[1].data.unit;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '流入带宽'){
                    return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit;
                  }
                  if(params[0].seriesName === '流出带宽'){
                    return params[0].name + '<br />' + '流出带宽：' + params[0].value + params[0].data.unit;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['流入带宽','流出带宽'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.day.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.time
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ (type ==='avg' ? dayavgunit : daymaxunit)
              }
            },
            series: [
              {
                name:'流入带宽',
                data: vueData.day.map((item, index) => {
                  if(type ==='avg'){
                    return {
                      value:this.bpsToSize(item.i_f_all_avg,dayavgunit),
                      unit:dayavgunit
                    }
                  }
                  if(type ==='max'){
                    return {
                      value:this.bpsToSize(item.i_f_all_max,daymaxunit),
                      unit:daymaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'流出带宽',
                data: vueData.day.map((item, index) => {
                  if(type === 'avg'){
                    return {
                      value:this.bpsToSize(item.o_f_all_avg,dayavgunit),
                      unit:dayavgunit
                    }
                  }
                  if(type === 'max'){
                    return {
                      value:this.bpsToSize(item.o_f_all_max,daymaxunit),
                      unit:daymaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          let optionMonth = {
            title: {
              text: '月带宽统计图' + '(单位:'+ (type ==='avg' ? monthavgunit : monthmaxunit) +')',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit + '<br />' + '流出带宽：' + params[1].value + params[1].data.unit;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '流入带宽'){
                    return params[0].name + '<br />' + '流入带宽：' + params[0].value + params[0].data.unit;
                  }
                  if(params[0].seriesName === '流出带宽'){
                    return params[0].name + '<br />' + '流出带宽：' + params[0].value + params[0].data.unit;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['流入带宽','流出带宽'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.month.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.time
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ (type ==='avg' ? monthavgunit : monthmaxunit)
              }
            },
            series: [
              {
                name:'流入带宽',
                data: vueData.month.map((item, index) => {
                  if(type ==='avg'){
                    return {
                      value:this.bpsToSize(item.i_f_all_avg,monthavgunit),
                      unit:monthavgunit
                    }
                  }
                  if(type ==='max'){
                    return {
                      value:this.bpsToSize(item.i_f_all_max,monthmaxunit),
                      unit:monthmaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'流出带宽',
                data: vueData.month.map((item, index) => {
                  if(type === 'avg'){
                    return {
                      value:this.bpsToSize(item.o_f_all_avg,monthavgunit),
                      unit:monthavgunit
                    }
                  }
                  if(type === 'max'){
                    return {
                      value:this.bpsToSize(item.o_f_all_max,monthmaxunit),
                      unit:monthmaxunit
                    }
                  }
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          if(btn === 'minu'){
            netMinu.setOption(optionMinu)
          }
          if(btn === 'hour'){
            netHour.setOption(optionHour)
          }
          if(btn === 'day'){
            netDay.setOption(optionDay)
          }
          if(btn === 'month'){
            netMonth.setOption(optionMonth)
          }
          if(btn === 'all'){
            netMinu.setOption(optionMinu)
            this.dialogNetMinu = false
            netHour.setOption(optionHour)
            this.dialogNetHour = false
            netDay.setOption(optionDay)
            this.dialogNetDay = false
            netMonth.setOption(optionMonth)
            this.dialogNetMonth = false
          }
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async CpuLiuliang() {
        this.dialogCpu = true
        let data = 'cmd=sys_report' +
          '&id='+ this.vps.id +
          '&cmd_type=cpu'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000' ) {
          let Cpu = echarts.init(document.getElementById('cpu'));
          let option = {
            title: {
              text: 'CPU使用统计图',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14,
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                return params[0].name + '<br />' + 'CPU使用情况：' + params[0].value + '%'
              }
            },
            color:['#7CB5EC'],
            legend: {
              data:['CPU使用情况'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.msg.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.logtime
              }),
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'+ '%'
              }
            },
            series: [
              {
                name:'CPU使用情况',
                data: vueData.msg.map((item, index) => {
                  return item.cpu
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
            ]
          };
          Cpu.setOption(option)
          this.dialogCpu = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async IopsLiuliang() {
        this.dialogIops = true
        let data = 'cmd=sys_report' +
          '&id='+ this.vps.id +
          '&cmd_type=cpu'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000' ) {
          let Iops = echarts.init(document.getElementById('iops'));
          let option = {
            title: {
              text: '磁盘使用统计图',
              x: 'center',
              textStyle:{
                color:'#666',
                fontWeight:'normal',
                fontSize:14,
              },
              top:14
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                  backgroundColor: '#ccc',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  shadowBlur: 0,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  textStyle: {
                    color: '#222'
                  }
                }
              },
              formatter: function (params) {
                if(params.length == 2){
                  return params[0].name + '<br />' + '写入IOPS：' + params[0].value + '<br />' + '读取IOPS：' + params[1].value;
                }
                if(params.length == 1){
                  if(params[0].seriesName === '写入IOPS'){
                    return params[0].name + '<br />' + '写入IOPS：' + params[0].value;
                  }
                  if(params[0].seriesName === '读取IOPS'){
                    return params[0].name + '<br />' + '读取IOPS：' + params[0].value;
                  }
                }
              }
            },
            color:['#7CB5EC','#434348'],
            legend: {
              data:['写入IOPS','读取IOPS'],
              x: 'center',
              y: 'bottom'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: vueData.msg.map((item, index) => {
                /*if(type === 'lastmonth' || type === 'month'){
                  return item.setdate
                }
                if(type === 'lastday'){
                  return item.cur_hour + '时'
                }*/
                return item.logtime
              }),
            },
            yAxis: {
              type: 'value',
            },
            series: [
              {
                name:'写入IOPS',
                data: vueData.msg.map((item, index) => {
                  return item.writeiops
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#7CB5EC'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#7CB5EC'}}
              },
              {
                name:'读取IOPS',
                data: vueData.msg.map((item, index) => {
                  return item.readiops
                }),
                itemStyle : {
                  normal : {
                    lineStyle:{
                      color:'#434348'
                    }
                  }
                },
                type: 'line',
                smooth: true,
                areaStyle: {normal: {color:'#434348'}}
              },
            ]
          };
          Iops.setOption(option)
          this.dialogIops = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.pwd_reset()
          } else {
            return false;
          }
        });
      },
      async submitForm2(formName) {
        this.os_setup()
      },
      async pwd_reset() {
        this.dialogLoading = true
        let data = 'cmd=pwd_reset'+
          '&id='+ this.vps.id +
          '&password=' + this.URLencode(this.psdForm.password)
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.psdForm.password =''
              self.psdForm.checkPass =''
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async vps_oslist() {
        let data = 'cmd=vps_oslist'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          let hash = {};
          this.Osname = vueData.msg.map((item, index) => {
            return {
              value:item.win_linux,
              label:item.win_linux
            }
          }).reduceRight((item, next) => {
            hash[next.value] ? '' : hash[next.value] = true && item.push(next);
            return item
          }, []);
          this.Osdata = vueData.msg
          this.Oslist = this.Osdata.filter(item => {
            return item.win_linux === this.Osnamec
          })
          this.Osid = this.Oslist[0].id
        }else {
          this.$toast('服务器繁忙，请重试','fail')
        }
      },
      changeYzm() {
        this.captcha = 'https://api.sanfengyun.com/www/yzm.php?rnd='+Math.random()
      },
      URLencode(sStr) {
        return escape(sStr).replace(/\+/g, '%2B').replace(/\"/g,'%22').replace(/\'/g, '%27').replace(/\//g,'%2F');
      },
      async os_setup() {
        this.dialogLoading = true
        let data = 'cmd=os_setup'+
          '&id='+ this.vps.id +
          '&img_yzm=' + this.Oscaptcha +
          '&os_id=' + this.Osid +
          '&password=' + this.URLencode(this.OspsdForm.password) +
          '&setup_type=' + this.Osstyle
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.OspsdForm.password = ''
          this.changeYzm()
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogShutdown = false
              self.VpsState()
            }})
        }else {
          this.OspsdForm.password = ''
          this.changeYzm()
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      getListIng() {
        // 这里是一个http的异步请求
        if(this.state){
          if (this.state.indexOf('正在') !=-1 && !this.timeOut) {
            let _this = this;
            this.timeOut = setTimeout(() => {
              this.kz_list()
              _this.getListIng()
            }, 2000);
          } else {
            this.timeOut = '';
          }
        }
      },
      async kz_list() {
        let data = 'cmd=kz_list'+
          '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.tableSnap = vueData.msg.map(item => {
            let name = '用户快照'
            if(item.bak_type === 'user'){
              name = '用户快照'
            }
            if(item.bak_type === 'sys'){
              name = '系统快照'
            }
            return {
              type:name,
              state:item.bak_state,
              time:item.bak_time,
              size:item.bak_size ? item.bak_size + 'G' : '',
              rate:item.bak_rate,
            }
          })
          this.getListIng()
        }else {
          this.$toast('服务器繁忙，请重试','fail')
        }
      },
      async kz_log_list() {
        let data = 'cmd=kz_log_list'+
          '&count=10'+
          '&page='+ this.page +
          '&id='+ this.vps.id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount
          this.tableSnaplog = vueData.msg.content.map(item => {
            return {
              time:item.do_time,
              event:item.do_result
            }
          })
        }else {
          this.$toast('服务器繁忙，请重试','fail')
        }
      },
      async Snap() {
        this.dialogProtect = false
        this.dialogLoading = true
        setTimeout(() => {
          this.dialogLoading = false
          this.kz_list()
        },5000)
        let data;
        if(this.snapevent === 'create'){
          data = 'cmd=kz_creat'+
            '&id='+ this.vps.id +
            '&img_yzm='+ this.Kuaizhao.captcha
        }
        if(this.snapevent === 'back'){
          let bak_type = this.snaptype === '用户快照' ? 'user' : 'sys'
          data = 'cmd=kz_reback'+
            '&id='+ this.vps.id +
            '&img_yzm='+ this.Kuaizhao.captcha +
            '&bak_type='+bak_type
        }
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000') {
          if(vueData.response != 200){
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.kz_log_list()
      },
      bpsToSize(bps,unit) {
        if (bps === 0) return '0';
        bps = bps*8
        let k = 1024,i = 0;
        if(unit == 'bps'){
          i = 0
        }
        if(unit == 'Kbps'){
          i = 1
        }
        if(unit == 'Mbps'){
          i = 2
        }
        return (bps / Math.pow(k, i)) > 1 ? (bps / Math.pow(k, i)).toPrecision(4) : (bps / Math.pow(k, i)).toFixed(4);
      },
      bpsToSize2(bps) {
        if (bps === '') return '';
        if (bps === 0) return 'bps';
        bps = bps*8
        var k = 1024, // or 1024
          sizes = ['bps','Kbps', 'Mbps'],
          i = Math.floor(Math.log(bps) / Math.log(k));

        return sizes[i];
      },
      getiavgMax(arr){
        let max = arr[0].i_f_all_avg
        for(let x in arr){
          if(arr[x].i_f_all_avg > max){
            max = arr[x].i_f_all_avg
          }
        }
        return max
      },
      getimaxMax(arr){
        let max = arr[0].i_f_all_max
        for(let x in arr){
          if(arr[x].i_f_all_max > max){
            max = arr[x].i_f_all_max
          }
        }
        return max
      },
      getoavgMax(arr){
        let max = arr[0].o_f_all_avg
        for(let x in arr){
          if(arr[x].o_f_all_avg > max){
            max = arr[x].o_f_all_avg
          }
        }
        return max
      },
      getomaxMax(arr){
        let max = arr[0].o_f_all_max
        for(let x in arr){
          if(arr[x].o_f_all_max > max){
            max = arr[x].o_f_all_max
          }
        }
        return max
      },
      VncConnect() {
        window.open('http://vnc.sanfengyun.com/admin-websocket.html?id='+window.btoa(this.session_id)+'&ip='+window.btoa(this.vpsInfo.ip))
      },
      /*async checkWeiXin() {
        this.delayLoading = true
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=check_wx_bind')
        if(state.code === '000' ) {
          if(vueData.response == 200) {
            this.delayLoading = false
            this.weixin = true
            this.nickname = vueData.msg.nickname
            this.headimgurl = vueData.msg.headimgurl
          }else {
            this.delayLoading = false
            this.weixin = false
          }
        }else {
          this.$toast('请刷新页面','fail')
        }
      },*/
      async checkDelay() {
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST','cmd=check_free_delay&ptype=vps')
        if(vueData.response == 200) {
          this.nexttime = vueData.msg.next_time
          if(vueData.msg.delay_enable == 0) {
            this.delayState = 0
          }else{
            this.delayState = vueData.msg.delay_state
          }
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      imgPreview (file) {
        let self = this;
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;

        if (/^image/.test(file.type)) {
          // 创建一个reader
          var reader = new FileReader();
          // 将图片将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function () {
            self.dataUrl = this.result;
          }
        }
        this.showimg = true
      },
      handleFileChange () {
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file  = inputDOM.files[0];
        // 这里就可以获取到文件的名字了
        this.fileName = this.file.name;

        this.imgPreview(this.file);
      },
      async submitrForm() {
        this.dialogLoading = true
        let formData = new window.FormData();
        formData.append('cmd', 'free_delay_add')
        formData.append('ptype', 'vps')
        formData.append('url', this.cardForm.url)
        formData.append('yanqi_img', this.$refs.inputer.files[0])
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',formData)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.showimg = false
              self.activeName = 'eight'
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async SearchCard() {

        let data = 'cmd=free_delay_list'+'&ptype=vps'+'&count='+ this.count1 + '&page='+ this.page1
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total1 = vueData.msg.allcount
          this.cardList = vueData.msg.content.map((item, index) => {
            return {
              id:index + 1,
              Img:item.img_fatie,
              Url:item.url,
              SetTime:item.SetTime,
              CheckTime:item.CheckTime,
              State:item.State,
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async getPostAddr() {
        let data = 'cmd=get_free_post_addr'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.post_addr = vueData.msg
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      handleCurrentChange1(val) {
        this.page1 = val;
        this.SearchCard()
      },
      handleSizeChange(val) {
        this.count1 = val
        this.SearchCard()
      },
      LargeImg(url) {
        this.dialogShowImg = true
        this.showimgurl = url
      },
      Linux(){
        const h = this.$createElement;
        MessageBox({
          title: '提示信息',
          message: h('div', null, [
            h('p', { style: 'font-size: 14px' }, '安装后请务必立刻修改您的宝塔账号和密码,否则服务器有被入侵的危险。')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'info'
        }).then(action => {
          window.open('http://'+ this.vpsInfo.ip + ':8888')
        }).catch(() => {

        });
      },
      Windows(){
        const h = this.$createElement;
        MessageBox.confirm('Windows操作系统由于镜像文件较大，为保证服务器性能，暂时只对收费客户开放，免费用户如需安装，需扣除2元安装费用。', '提示信息',{
          showCancelButton: false,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'info'
        }).then(action => {

        }).catch(() => {

        });
      },
      async getPhone() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=userinfo')

        if(vueData.response == 200 ) {
          this.phone = vueData.msg.ID_Mobile
        }else{
          this.$toast('刷新试一下','fail')
        }
      },
      async getPsd() {
        this.dialogLoading = true
        let self = this
        let data = 'cmd=os_setup_yzm'+
          '&img_yzm='+ this.Oscaptcha
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          this.$dialog({type:'success', info: vueData.msg, click () {self.dialogCaptcha = false}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {self.changeYzm()}})
        }
      }
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
    background-color: #fff;
  }
  .page-main { border: 0}
  .panel-heading { padding: 5px 0 0 0; }
  .hideleft { margin-left: 80px; }
  .server-header {
    height: 96px;
    margin-top: 18px;
    margin-bottom: 15px;
    background-repeat: no-repeat;
    background-position: left center;
  }
  .server-windows {
    background-image: url(../../assets/imgs/windows.png);
  }
  .server-windows.server-close {
    background-image: url(../../assets/imgs/windows-close.png);
  }
  .server-centos {
    background-image: url(../../assets/imgs/centos.png);
  }
  .server-centos.server-close {
    background-image: url(../../assets/imgs/centos-close.png);
  }
  .server-ubuntu {
    background-image: url(../../assets/imgs/ubuntu.png);
  }
  .server-ubuntu.server-close {
    background-image: url(../../assets/imgs/ubuntu-close.png);
  }
  .server-header > p {
    margin: 10px 0;
    font-size: 12px;
    color: #a0a2a3;
  }
  .server-header > p > span {
    margin-right: 25px;
  }
  .server-header-table {
    margin-left: 120px;
  }
  .server-header-table td {
    padding-bottom: 8px;
    font-size: 12px;
    color: #a0a2a3;
  }
  .server-header-table .z-color-green-state {
    color:#29cc7a;
  }
  .server-header .state-icon {
    display: inline;
    padding-left: 22px;
    font-size: 12px;
  }
  .state-icon {
    background: no-repeat left center;
  }
  .server-state-run {
    background-image: url(../../assets/imgs/server_state_run.png);
    color: #29cc7a;
  }
  .server-state-stop {
    background-image: url(../../assets/imgs/server_state_stop.png?v=2);
    color: #ff0000;
  }
  .row-title {
    background-color: #f7f9fa;
    font-size: 12px;
    color: #636566;
    font-weight: 700;
    padding-left: 16px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    line-height: 40px;
  }
  .row-border { border-bottom: 1px solid #eee; }
  .grid-content {
    line-height: 50px;
  }
  .grid-content-small {
    line-height: 35px;
  }
  .change-name .edit-name { display: inline-block;}
  .edit-name {
    display: none;
    width: 14px;
    height: 14px;
    background: url(../../assets/imgs/server_edit.png) no-repeat center;
    vertical-align: -1.5px;
    cursor: pointer;
  }
  .alert-warn {
    margin-bottom: 20px;
  }
  .server-monitor-box {
    float: left;
    position: relative;
    z-index: 10;
    width: 100%;
    height: 374px;
    margin-bottom: 25px;
    border: 1px solid #e8eced;
  }
  .server-monitor-content.list .server-monitor-box {
    width: 48%;
  }
  .server-monitor-content.list .server-monitor-box:first-child,
  .server-monitor-content.list .server-monitor-box:first-child + .server-monitor-box + .server-monitor-box {
    margin-right: 2%;
  }
  .server-monitor-box > div.charts-container {
    width: 100%;
    height: 374px;
  }
  .server-monitor-box .server-monitor-btn {
    position: absolute;
    left: 20px;
    top: 12px;
    z-index: 1;
  }
  .server-monitor-content.cpu .server-monitor-box {
    width: 98%;
  }
  .error-img {
    width: 100px;
    height: 30px;
    vertical-align: -10px;
    margin-left: 10px;
    cursor: pointer;
  }

  .host-uselevel-bar.progress {
    display: inline-block;
    margin-bottom: -11px;
    height: 32px;
    border-radius: 0;
  }
  .host-uselevel-bar {
    position: relative;
    width: 300px;
  }
  .host-uselevel-bar .progress-bar-blue {
    background: #00aaff;
  }
  .usage-text {
    position: absolute;
    left: 43%;
    top: 10px;
    line-height: 1;
    margin-left: -20px;
  }
  .progress {
    height: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
  }
  .progress-bar {
    float: left;
    width: 0;
    height: 100%;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    background-color: #337ab7;
    -webkit-box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    -webkit-transition: width .6s ease;
    -o-transition: width .6s ease;
    transition: width .6s ease;
  }
  .alert-info {
    margin-bottom: 20px;
  }
  .alert-deng {
    margin-bottom: 50px;
  }
  .red-chunk {
    display: inline-block;
    background-color: #e35a55;
    color: #fff;
    padding: 2px 6px;
  }
  .col-img {
    border: solid 1px #bbbaba;
    width: 135px;
    height: 102px;
    border-radius: 3px;
    margin-right: 10px;
  }
  .choose-file {
    display: inline-block;
    position: absolute;
    padding: 4px 12px;
    margin-bottom: 0;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    color: #fff;
    border-color: #2082dd;
    background-color: #2a89e0;
    border-radius: 2px;
  }
  .delaybox {
    width: 374px;
    height: 180px;
    background: #fafafa;
    border: 1px solid #bababa;
    text-align: center;
    margin-left: 40px;
  }
  .eye-open {
    position: absolute;
    top: 6px;
    right: 1px;
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(../../assets/imgs/eye_open.png) no-repeat center;
    background-size: 100%;
    vertical-align: -1.5px;
    cursor: pointer;
  }
  .eye-close {
    position: absolute;
    top: 6px;
    right: 1px;
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(../../assets/imgs/eye_close.png) no-repeat center;
    background-size: 100%;
    vertical-align: -1.5px;
    cursor: pointer;
  }
  .guanggao-link {
    background-color: #ff4401;
    /*background-color: #C52B2B;*/
  }
  .act-box {
    background-color: #ff4401;
    font-size: 16px;
    color: #fff;
    line-height: 58px;
  }
  .act-box span {
    font-size: 16px;
    color: #ffff00;
  }
</style>





// WEBPACK FOOTER //
// src/pages/product/freeServer.vue